// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/types/v1/curve_type.proto (package quanterix.common.types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/common/types/v1/curve_type.proto.
 */
export const file_quanterix_common_types_v1_curve_type: GenFile = /*@__PURE__*/
  fileDesc("CipxdWFudGVyaXgvY29tbW9uL3R5cGVzL3YxL2N1cnZlX3R5cGUucHJvdG8SGXF1YW50ZXJpeC5jb21tb24udHlwZXMudjEqnAEKCUN1cnZlVHlwZRIaChZDVVJWRV9UWVBFX1VOU1BFQ0lGSUVEEAASFQoRQ1VSVkVfVFlQRV9MSU5FQVIQARIYChRDVVJWRV9UWVBFX1FVQURSQVRJQxACEhQKEENVUlZFX1RZUEVfQ1VCSUMQAxIVChFDVVJWRV9UWVBFX0ZPVVJQTBAEEhUKEUNVUlZFX1RZUEVfRklWRVBMEAViBnByb3RvMw");

/**
 * Represents a curve fitting equation (e.g. 5PL, 4PL, etc.)
 *
 * @remarks
 * This type is equivalent to quanterix.protos.type.CurveType
 *
 * @generated from enum quanterix.common.types.v1.CurveType
 */
export enum CurveType {
  /**
   * Unspecified
   *
   * @generated from enum value: CURVE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Represents a linear curve
   *
   * @generated from enum value: CURVE_TYPE_LINEAR = 1;
   */
  LINEAR = 1,

  /**
   * Represents a quadratic curve
   *
   * @generated from enum value: CURVE_TYPE_QUADRATIC = 2;
   */
  QUADRATIC = 2,

  /**
   * Represents a cubic curve
   *
   * @generated from enum value: CURVE_TYPE_CUBIC = 3;
   */
  CUBIC = 3,

  /**
   * Represents a 4-Parameter Logistic Curve
   *
   * @generated from enum value: CURVE_TYPE_FOURPL = 4;
   */
  FOURPL = 4,

  /**
   * Represents a 5-Parameter Logistic Curve
   *
   * @generated from enum value: CURVE_TYPE_FIVEPL = 5;
   */
  FIVEPL = 5,
}

/**
 * Describes the enum quanterix.common.types.v1.CurveType.
 */
export const CurveTypeSchema: GenEnum<CurveType> = /*@__PURE__*/
  enumDesc(file_quanterix_common_types_v1_curve_type, 0);

